import React from "react";

const Banner = ({ desktopImage, mobileImage, alt = "", className = "" }) => {
  return (
    <picture>
      {/* Imagine pentru telefon */}
      <source media="(max-width: 768px)" srcSet={mobileImage} />

      {/* Imagine pentru desktop (default) */}
      <img src={desktopImage} alt={alt} className={className} />
    </picture>
  );
};

export default Banner;